import { Pipe, PipeTransform, Injectable } from '@angular/core';
import * as momentImported from 'moment'; const moment = momentImported;

@Pipe({
    name: 'getDate',
})

@Injectable()
export class DateFormatPipe implements PipeTransform {
    transform(dateTime: string): any {
        if (!dateTime) {
            return '';
        }

        return moment(dateTime).format('DD/MM/YY');
    }
}
